<template>
    <div class="container">
      <div class="containers">
        <img src="../assets/developing.png" alt="" />
        <p>{{ title }}</p>
      </div>
      <Foot />
    </div>
  </template>
  
  <script>
  import Foot from "./Foot.vue";
  export default {
    name: "",
    components: { Foot },
    props: {},
    data() {
      return {
        title:'功能正在建设中...'
      };
    },
    computed: {},
    watch: {},
    created() {
      console.log(this.$route.query.title)
      if(this.$route.query.title&&this.$route.query.title != ''){
        this.title=this.$route.query.title
      }
      
    },
    mounted() {
      // console.log(this.$router.params.title)
      // if(this.$route.query.title){
      //   this.title = this.$route.query.title
      // }
      
    },
    methods: {},
  };
  </script>
  
  <style scoped lang="less">
  .container {
    width: 100%;
    height: calc(100% - 81px);
    // background: #f6f8fe;
    overflow: hidden;
    //   display: flex;
    //   flex-direction: column;
    //   justify-content: center;
    //   align-items: center;
    // padding: 20px 0;
    .containers {
      width: 80%;
      height: calc(100% - 200px);
      margin: 60px auto;
      // height: calc(100% - 100px);
      // margin: 0 auto;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      background: #fff;
      padding-top: 100px;
      box-sizing: border-box;
    }
    img {
      background-size: 100%;
    }
    p{
      line-height: 80px;
      font-size: 18px;
      color: #5780F2;
    }
    // img{
    //     width: 100%;
    //     height: 100%;
    //     background-size: 100% 100%;
    // }
  }
  </style>
  